export const NotificationTypes = {
  CALL_SERVER: 1,
  SURVEY_POSTED: 2,
  SERVER_APP_CARD_PAYMENT: 3,
  SERVER_APP_CASH_PAYMENT: 4,
  GUEST_APP_CARD_PAYMENT: 5,
  KIOSK_TABLE_CHECK_IN: 6,
  GUEST_APP_CHECK_IN: 7,
  SERVER_APP_PRINTER: 8,
  NEW_ORDER: 9,
  PRINT_SERVER_PRINT: 18,
};

export const NotificationTypeIdToFilterKey = {
  [NotificationTypes.CALL_SERVER]: 'callServer',
  [NotificationTypes.SERVER_APP_CARD_PAYMENT]: 'cardPayment',
  [NotificationTypes.SERVER_APP_CASH_PAYMENT]: 'cashPayment',
  [NotificationTypes.GUEST_APP_CHECK_IN]: 'guestCheckIn',
  [NotificationTypes.KIOSK_TABLE_CHECK_IN]: 'guestCheckIn',
  [NotificationTypes.NEW_ORDER]: 'itemOrdered',
  [NotificationTypes.SURVEY_POSTED]: 'surveyPosted',
  [NotificationTypes.SERVER_APP_PRINTER]: 'orderPrinted',
  [NotificationTypes.PRINT_SERVER_PRINT]: 'receiptPrinted',
};